import React from 'react'
import Resume from '../components/resume/Resume'

const AboutPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-4 pt-24 pb-12">
      <Resume />
    </div>
  )
}

export default AboutPage
